<div
  class="sz-text-input"
  [class.sz-text-input--error]="errorText() !== null"
  [class.sz-text-input--disabled]="disabledState()">
  @if (label(); as labelText) {
    <label class="sz-text-input__label" [attr.for]="inputId()">{{ labelText }}</label>
  }
  <div class="sz-text-input__field" [class.sz-text-input__field--with-prefix]="prefixIcon() !== null">
    @if (prefixIcon(); as iconName) {
      <span class="sz-text-input__icon" aria-hidden="true">
        <sz-icon [name]="iconName" [size]="18" />
      </span>
    }
    <input
      class="sz-text-input__input"
      [id]="inputId()"
      [type]="type()"
      [placeholder]="placeholder()"
      [value]="value()"
      [disabled]="disabledState()"
      [attr.autocomplete]="autocomplete()"
      [attr.maxlength]="maxLength()"
      (input)="onInput($event)"
      (blur)="onBlur()" />
  </div>
  <div class="sz-text-input__meta">
    @if (errorText(); as err) {
      <span class="sz-text-input__error">{{ err }}</span>
    } @else if (helperText(); as helper) {
      <span class="sz-text-input__helper">{{ helper }}</span>
    }
    @if (showCounter() && maxLength() !== null) {
      <span class="sz-text-input__counter">{{ value().length }}/{{ maxLength() }}</span>
    }
  </div>
</div>
